import axios from '../axios/interceptor';
import dummyRevenueDashboardData from './mock/response/revenueDashboard.json';

export const getRevenueDashboard = async (businessId,fromDate="", toDate="", revenueType=0)=>{
    const payload = {
        fromDate: fromDate,
        toDate: toDate,
        revenueType: revenueType
    }
    const response = await axios.post(`/business/${businessId}/revenue-dashboard`, payload);
    return response.data;
}